<template>
  <div class="template">
    <template v-if="userSettingsStore.hasPermission('SOCIETAL')">
      <PetitionsParams />
      <LoaderFullPage v-if="store.loading" />
      <PetitionsDatas v-else />
    </template>
    <template v-else>
      <PetitionFreemiumPopup />
    </template>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";

import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import PetitionsParams from "@follaw-fr/components/petitions/organisms/PetitionsParams.vue";
import PetitionsDatas from "@follaw-fr/components/petitions/organisms/PetitionsDatas.vue";
import { usePetitionsStore } from "@follaw-fr/stores/petitions";
import { useUserSettingsStore } from "@follaw-fr/stores/user-settings";
import PetitionFreemiumPopup from "@follaw-fr/components/petitions/molecules/PetitionFreemiumPopup.vue";
import { PermissionLevel } from "@/follaw-fr/constants/enums/permission-level.enum";

const store = usePetitionsStore();
const router = useRouter();
const userSettingsStore = useUserSettingsStore();

store.isFollawedActive =
  router.currentRoute.value.fullPath.includes("follawed");

if (userSettingsStore.hasPermission(PermissionLevel.SOCIETAL)) {
  store.selectedFilters.from = 0;
  store.fetchPetitionsList();
}
</script>
